import { Box } from '@pets-ui/Box/Box'
import { Skeleton } from '@pets-ui/Skeleton/Skeleton'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import { SUBTITLE_CHIPS_TWO_ROWS_HEIGHT } from './SubtitleChipsRow'

const CARD_WIDTH = 172

interface ProductCardSkeletonProps {
  hasSubtitleChips?: boolean
}

export const ProductCardSkeleton = ({ hasSubtitleChips = false }: ProductCardSkeletonProps) => {
  return (
    <VStack
      width={CARD_WIDTH}
      backgroundColor={colors.white}
      borderWidth={1}
      borderStyle="solid"
      borderColor={colors.grey200}
      borderRadius={4}
      overflow="hidden"
      flexShrink={0}
    >
      <Skeleton width={CARD_WIDTH} height={CARD_WIDTH} />
      <VStack px={2} py={2} gap={1} flex={1}>
        <Box minHeight="40px">
          <Skeleton width="100%" height={16} />
          <Skeleton width="60%" height={16} />
        </Box>
        {hasSubtitleChips && (
          <Skeleton width="100%" height={SUBTITLE_CHIPS_TWO_ROWS_HEIGHT} />
        )}
        <Skeleton width={60} height={20} />
        <Skeleton width={96} height={28} />
      </VStack>
    </VStack>
  )
}
